import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {MediaGalleryType} from "../../definitions/types";

export const name = "mediaGallery";

const mediaGallery = createSlice({
    name: name,
    initialState: {
        value: {
            activeIndex: 0,
            modal: {
                show: false,
                zoom: 1,
                showZoomHint: true
            }
        } as MediaGalleryType
    },
    reducers: {
        setActiveIndex: (state, action: PayloadAction<number>) => {
            state.value = {
                ...state.value,
                activeIndex: action.payload
            }
        },
        showModal: (state) => {
            state.value = {
                ...state.value,
                modal: {
                    ...state.value.modal,
                    show: true
                }
            }
        },
        hideModal: (state) => {
            state.value = {
                ...state.value,
                modal: {
                    ...state.value.modal,
                    show: false
                }
            }
        },
        setZoom: (state, action: PayloadAction<1 | 2 | 3 | 4 | 5>) => {
            state.value = {
                ...state.value,
                modal: {
                    ...state.value.modal,
                    zoom: action.payload
                }
            }
        },
        hideZoomHint: (state) => {
            state.value = {
                ...state.value,
                modal: {
                    ...state.value.modal,
                    showZoomHint: false
                }
            }
        }
    }
});

export const mediaGalleryActions = {
    setActiveIndex: mediaGallery.actions.setActiveIndex,
    modal: {
        show: mediaGallery.actions.showModal,
        hide: mediaGallery.actions.hideModal,
        setZoom: mediaGallery.actions.setZoom,
        hideZoomHint: mediaGallery.actions.hideZoomHint
    }
};

export default mediaGallery.reducer;